import { trpc } from '~/utils/trpc'

export const useLogin = () => {
  return trpc.auth.login.useMutation({
    onSuccess: ({ url }) => {
      window.location.href = url // redirect to sgID
    },
  })
}
